// IDEA remove Modal modal-react-native-web & use react-native-web's
// WHEN its merged https://github.com/necolas/react-native-web/pull/1646
export { default as Modal } from 'modal-react-native-web';
